import { User } from "../../../model/User";

export const ORGLESS_USERS: User[] = [];
